// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"7aa73e0c","92":"49cf7c97","138":"fec9cf46","367":"7899f35a","554":"128f63e9","639":"a70b85b1","771":"ef1b4ba6","793":"8a690490","866":"805e9931","961":"fb60ac84"}[chunkId] + ".chunk.js";
};